export default __webpack_public_path__ + "navigation-examples-offline-regions-thumbnail-480-ef25a6fe5df7db61972856ce05813200.png";